import { Box, Switch, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { CARD, TITLE } from '../styles';
import { useAppSettings, useUpdateAppSettings } from '../useSettingsData';

export const NotificationsCard = () => {
  const { data: settingsData } = useAppSettings();
  const updateSettings = useUpdateAppSettings();

  const [notifs, setNotifs] = useState({ newAdmission: true, newInstallment: true });

  useEffect(() => {
    if (settingsData) {
      setNotifs(settingsData.notifications);
    }
  }, [settingsData]);

  const handleNotifChange = (key: 'newAdmission' | 'newInstallment', value: boolean) => {
    const next = { ...notifs, [key]: value };
    setNotifs(next);
    // Must always send BOTH notification keys together — partial object overwrites the whole subdoc
    updateSettings.mutate({ notifications: next });
  };

  return (
    <Box sx={CARD}>
      <Typography sx={TITLE}>Notifications</Typography>
      <Typography sx={(theme) => ({ fontSize: 13, color: theme.palette.grey[500], mt: '4px', mb: '20px' })}>
        Manage how you receive notifications.
      </Typography>

      <Typography sx={(theme) => ({
        fontSize: 11.5, fontWeight: 700, color: theme.palette.grey[400],
        textTransform: 'uppercase', letterSpacing: '0.07em', mb: '12px',
      })}>
        Notification Types
      </Typography>

      {(
        [
          { key: 'newAdmission'   as const, label: 'New Admission',   sub: 'When a new Admission Submit' },
          { key: 'newInstallment' as const, label: 'New Installment', sub: 'When a new Installment Submit' },
        ]
      ).map(({ key, label, sub }, idx, arr) => (
        <Box
          key={key}
          sx={(theme) => ({
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            py: '16px',
            borderBottom: idx < arr.length - 1 ? `1px solid ${theme.palette.grey[100]}` : 'none',
          })}
        >
          <Box>
            <Typography sx={(theme) => ({ fontSize: 14, fontWeight: 600, color: theme.palette.grey[900] })}>{label}</Typography>
            <Typography sx={(theme) => ({ fontSize: 13, color: theme.palette.grey[500], mt: '2px' })}>{sub}</Typography>
          </Box>
          <Switch
            checked={notifs[key]}
            onChange={(e) => handleNotifChange(key, e.target.checked)}
            sx={(theme) => ({
              '& .MuiSwitch-switchBase.Mui-checked': { color: theme.palette.primary.main },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: theme.palette.primary.main },
            })}
          />
        </Box>
      ))}
    </Box>
  );
};
